import { Box } from "@mui/material";
import { styled } from "@mui/system";

const StyledWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "20px",
  padding: "0 12px",
  boxSizing: "border-box",
  userSelect: "none",
  touchAction: "pan-y",

  ".mobile-image-row": {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
  },

  ".mobile-arrow": {
    flexShrink: 0,
    width: "44px",
    height: "44px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    cursor: "pointer",
    "& .arrow-icon": {
      fontSize: "22px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "36px",
      height: "36px",
      "& .arrow-icon": { fontSize: "20px" },
    },
    "&.speakers": {
      backgroundColor: theme.palette.primary.main,
      "& .arrow-icon": { color: theme.palette.white.main },
    },
    "&.organizer": {
      backgroundColor: theme.palette.white.main,
      "& .arrow-icon": { color: theme.palette.primary.main },
    },
  },

  ".mobile-image": {
    flex: "0 0 auto",
    width: "400px",
    height: "400px",
    borderRadius: "50%",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    [theme.breakpoints.down("sm")]: {
      width: "260px",
      height: "260px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "210px",
      height: "210px",
    },
  },

  ".mobile-name": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    width: "100%",
    minWidth: 0,
  },

  ".mobile-name-line": {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "8px",
  },

  ".mobile-firstname": {
    fontSize: "34px",
    lineHeight: 1.2,
    textAlign: "center",
    color: theme.palette.primary.main,
    overflowWrap: "anywhere",
    "&.organizer": {
      color: theme.palette.white.main,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "18px",
    },
  },

  ".mobile-lastname": {
    fontSize: "30px",
    lineHeight: 1.2,
    textAlign: "center",
    color: theme.palette.common.black,
    overflowWrap: "anywhere",
    "&.organizer": {
      color: theme.palette.white.main,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "18px",
    },
  },

  ".mobile-role": {
    fontSize: "20px",
    lineHeight: 1.3,
    textAlign: "center",
    color: theme.palette.common.black,
    "&.organizer": {
      color: theme.palette.white.main,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
    },
  },

  ".mobile-description-card": {
    width: "100%",
    backgroundColor: theme.palette.primary.main,
    padding: "18px 16px",
    boxSizing: "border-box",
  },

  ".mobile-description": {
    fontSize: "14px",
    lineHeight: 1.5,
    color: theme.palette.white.main,
    textAlign: "left",
    whiteSpace: "pre-wrap",
  },
}));

export default StyledWrapper;
